<template>
  <div class="w-100 h-100">
    <b-container fluid>
      <h2 class="tw-mb-0 text-aegis-dk">Query Builder</h2>
      <p class="tw-italic tw-text-gray-700">
        Build custom queries
      </p>
    </b-container>
    <br />

    <b-row>
        <b-col cols="3">
            <b-form-group
                id="fieldset-1"
                label-for="model"
            >
                <b-form-select id="model" v-model="filterModel" :options="modelOptions"></b-form-select>
            </b-form-group>
        </b-col>

        <b-col cols="6">
            <b-form-group
                id="fieldset-1"
                label-for="input-1"
            >
                <b-input-group>
                    <b-form-input
                        id="input-1"
                        v-model="search_phrase"
                        trim v-on:keydown.enter="updateTable"
                        placeholder="Enter a keyword to search across all fields..."
                    ></b-form-input>
                    <b-input-group-append>
                        <b-button variant="success" @click="updateTable"><i class="fa fa-search"></i></b-button>
                    </b-input-group-append>
                </b-input-group>
            </b-form-group>
        </b-col>
        <b-col>
            <b-button style="width: 90px;" size="sm" @click="clear">
                Clear
            </b-button>
        </b-col>

    </b-row>

    <b-row v-for="index in queryFieldsetCount" :key="index">
        <b-input-group>
            <b-col cols="3" class="mt-1">
                <b-form-select
                    v-model="fieldArray[index - 1]"
                    :options="fieldOptions"
                >
                </b-form-select>
            </b-col>
            <b-col cols="3" class="mt-1">
                <b-form-select v-model="operatorArray[index - 1]">
                    <option
                        v-for="(operator, idx) in operatorOptionsArray"
                        :key="idx"
                        :value="operator.value"
                        :title="operator.title || null"
                    >
                        {{ operator.text }}
                    </option>
                </b-form-select>
            </b-col>
            <b-col cols="3" class="mt-1">
                <b-form-group
                    id="fieldset-1"
                    label-for="input-1"
                >
                <b-input-group>
                    <b-form-input
                        id="input-1"
                        v-model="termArray[index - 1]"
                        trim v-on:keydown.enter="updateTable"
                        placeholder="Enter a search term..."
                    ></b-form-input>
                    <b-input-group-append>
                        <b-button variant="success" @click="updateTable"><i class="fa fa-search"></i></b-button>
                    </b-input-group-append>
                </b-input-group>
            </b-form-group>
            </b-col>
            <b-col class="mt-1">
                <b-button
                    v-if="queryFieldsetCount > 1"
                    class="mr-1"
                    size="sm"
                    @click="removeQueryFieldset(index - 1)"
                >-</b-button>
                <b-button v-else class="mr-1" disabled size="sm">-</b-button>
                <b-button
                    v-if="index === queryFieldsetCount"
                    class="mr-1"
                    size="sm"
                    @click="incrementQueryFieldset"
                >+</b-button>
            </b-col>
        </b-input-group>
    </b-row>

    <b-row>
        <b-col>
            <small>Total Results: {{ totalRows }} <i @click="downloadFile" class="fa fa-download text-success" v-b-modal.report-modal style="margin-left: 10px; cursor: pointer;" title="Download All"></i></small>
        </b-col>
    </b-row>

    <div style="width: 100%; overflow: auto;">
        <b-table
            ref="resultTable"
            striped
            hover
            :items="find"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :tbody-tr-class="'clickable'"
            :busy.sync="tableBusy"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
        >
        <!-- Replace rows with a busy spinner while the table data is loading. -->
        <!-- https://bootstrap-vue.org/docs/components/table#table-busy-state -->
        <template #table-busy>
        <div class="text-danger my-2">
            <b-spinner class="align-left"></b-spinner>
            <strong>&nbsp;Loading...</strong>
        </div>
        </template>
      </b-table>
    </div>

    <b-row>
        <b-col cols="2">
            <b-form-group id="fieldset-2" label="Results Per Page" label-for="input-2">
                <b-form-select id="input-2" v-model="perPage" :options="perPageOptions"></b-form-select>
            </b-form-group>
        </b-col>
        <b-col class="my-1" cols="9" style="padding-top: 30px;">
            <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="fill"
            size="sm"
            class="my-0"
            ></b-pagination>
        </b-col>
    </b-row>
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";
import * as _ from "lodash";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

export default {
  mixins: [
    // BaseTemplate,
    DashboardBaseTemplate,
  ],
  components: {},
  props: {},
  data: function() {
    return {
        sortBy: 'id',
        sortDesc: true,
        tableData: [],
        fields: [],  // Defines the table fields
        totalRows: 0,
        currentPage: 1,
        perPage: 20,
        title: "",
        search_phrase: null,
        search_term: null,
        perPageOptions: [
            10,
            15,
            20,
            25,
            50
        ],
        queryFieldsetCount: 1,  // the number of sets of query fields
        fieldArray: [],  // array of selected fields from the 'Select a field' inputs
        operatorArray: [],  // array of operator arguments from the 'Select an operator' inputs
        termArray: [],  // array of search arguments from the 'Enter a search term...' inputs
        filterModel: "Select a model",
        filterColumn: "Select a column",
        filterOperator: "Select an operator",
        modelOptions: ["Select a model"],
        fieldOptions: ["Select a column"], // array of column arguments from the 'Select a column' fields
        operatorOptionsArray: [
            { value: '', text: 'Select an operator', disabled: true },
            { value: 'eq', text: '=' , title: 'Case sensitive. Searches for rows where the requested column is an exact match for the provided string.'},
            { value: 'neq', text: '!=' , title: 'Case sensitive. Searches for rows where the requested column is not an exact match for the provided string.'},
            { value: 'contains', text: 'contains' , title: 'Not case sensitive. Searches for rows where the requested column contains the provided string.'},
            { value: 'ncontains', text: '!contains' , title: 'Not case sensitive. Searches for rows where the requested column does not contain the provided string.'},
            { value: 'sw', text: 'Starts with', title: 'Case sensitive. Searches for rows where the requested column starts with the provided string.'},
            { value: 'nsw', text: '!Starts with', title: 'Case sensitive. Searches for rows where the requested column does not start with the provided string.'},
            { value: 'lt', text: '<' , title: 'Searches for rows where the requested column value is less than the provided numerical input.'},
            { value: 'lte', text: '<=' , title: 'Searches for rows where the requested column value is less than or equal to the provided numerical input.'},
            { value: 'gt', text: '>', title: 'Searches for rows where the requested column value is greater than the provided numerical input.'},
            { value: 'gte', text: '>=' , title: 'Searches for rows where the requested column value is greater than or equal to the provided numerical input.'},
            { value: 'in', text: 'in', title: 'Case sensitive. Individual terms deliniated by a "|" character. Searches for rows where the requested column value is equal to one of the strings in the provided list.'},
            { value: 'nin', text: '!in', title: 'Case sensitive. Individual terms deliniated by a "|" character. Searches for rows where the requested column value is not equal to one of the strings in the provided list.'},
        ],
        tableBusy: false,
        fileDownload: false
    };
  },
  computed: {},
  watch: {
    filterModel: function(){
        // this.clear();
        this.getModelColumns();
        // this.updateTable();
    },
    sortBy: function () {
      this.addUrlQueryParams();
    },
    sortDesc: function () {
      this.addUrlQueryParams();
    },
  },
  created: function() {
    // this.setUpFields(this.$route.params.view);
    // this.fieldArray[0] = "";
    // this.operatorArray[0] = "";
    this.unpackUrlQueryParams(this.$route.query);
  },
  mounted: function() {
    let that = this;
    // load drop-down options
    HTTP.get("/kenya/report_builder_options/")
      .then((response) => {
        _.each(response.data.models, function(item){
          that.modelOptions.push(item);
        });
      })
      .catch((error) => {
        HandleErrors.HandleErrors(error);
      })
  },
  methods: {
    addUrlQueryParams() {
        // when called, add the values of local vars into the URL as query params.
        let query = {};
        if (this.filterModel) {
            query["model"] = this.filterModel;
        }
        if (this.search_phrase) {
            query["search_phrase"] = this.search_phrase;
        }
        if (this.fieldArray[0]) {
            query["field"] = this.fieldArray;
        }
        if (this.operatorArray[0]) {
            query["operator"] = this.operatorArray;
        }
        if (this.termArray[0]) {
            query["term"] = this.termArray;
        }
        if (this.sortBy != "id" && this.sortBy != "") {
            query["sort_by"] = this.sortBy;
        }
        if (this.sortDesc) {
            query["sort_desc"] = true;
        }
        this.$router.push({ query }).catch((err) => {
            this.route_err = err;
        });
    },
    unpackUrlQueryParams(query_obj) {
        // if there are query params in the URL fetch them and load them into local vars. For example:
        // http://localhost:8080/vectraits-datasets?keywords=aedes&field=OriginalID&field=OriginalTraitName&operator=sw&operator=contains&term=MSS&term=wing
        this.filterModel = "";
        if ("model" in query_obj) {
            this.filterModel = query_obj.model;
        }
        this.search_phrase = "";
        if ("search_phrase" in query_obj) {
            this.search_phrase = query_obj.search_phrase;
        }
        this.fieldArray = undefined;
        this.operatorArray = undefined;
        this.termArray = undefined;
        this.fieldArray = this.extractArrayFromQuery(this.$route.query, "field");
        this.operatorArray = this.extractArrayFromQuery(this.$route.query, "operator");
        this.termArray = this.extractArrayFromQuery(this.$route.query, "term");
        this.queryFieldsetCount = this.fieldArray.length;
        this.sortBy = "id";
        if ("sort_by" in this.$route.query) {
            this.sortBy = this.$route.query.sort_by;
        }
        this.sortDesc = false;
        if ("sort_desc" in this.$route.query) {
            this.sortDesc = true;
        }
    },
    clearUrlQueryParams() {
      // clear URL query params
      this.$router.push({ query: {} }).catch((err) => {
        this.route_err = err;
      });
    },
    extractArrayFromQuery(queryObject, param){
        // flush array

        let arr = [];

        // if the given parameter is in the query object, assign the local array the param's contents
        if (param in queryObject) {
            // It appears that if there is only one value in a $route.query key, it is a string. If there are more
            // than one it is an array. Because of that, we have to check the type of the parameter before we can 
            // assign it properly.
            if ((typeof queryObject[param]) == "string") {
                arr[0] = queryObject[param];
            } else {
                arr = queryObject[param];
            }

        // else set the first element of the array to an empty string to allow the field's default text to show
        } 
        else {
            arr[0] = '';
        }
        return arr;
    },
    downloadFile: function(){
        let that = this;
        var params = that.buildRequestParams();
        params.append("return_as", "csv");

        HTTP.get("/kenya/report_builder", {params: params}).then(response => {
            var fileURL = window.URL.createObjectURL(
                new Blob([response.data])
            );
            var fileLink = document.createElement("a");
            fileLink.href = fileURL;
            // const today = new Date();
            // fileLink.setAttribute("download", "DataExport-" + today + ".csv");
            fileLink.setAttribute("download", "DataExport.csv");
            document.body.appendChild(fileLink);
            fileLink.click();
        });
    },
    updateTable: function(){
        this.$refs.resultTable.refresh();
        this.addUrlQueryParams();
    },
    buildRequestParams () {
        let that = this;
        var params = new URLSearchParams();
        params.append("sort_column", that.sortBy);
        params.append("sort_dir", that.sortDesc ? "desc" : "asc");

        if(that.filterModel && that.filterModel != ''){
            params.append("model", that.filterModel);
        }
        
        if(that.search_phrase && that.search_phrase != ''){
            params.append("search_phrase", that.search_phrase);
        }
        // load fieldArray, operatorArray, and termArray into the params obj
        var i;
        for (i = 0; i < that.fieldArray.length; i++) {
            if (that.fieldArray[i].length != 0) {
            params.append("field", that.fieldArray[i]);
            }
        }
        var j;
        for (j = 0; j < that.operatorArray.length; j++) {
            if (that.operatorArray[j].length != 0) {
            params.append("operator", that.operatorArray[j]);
            }
        }
        var k;
        for (k = 0; k < that.termArray.length; k++) {
            if (that.termArray[k].length != 0) {
            params.append("term", that.termArray[k]);
            }
        }
        return params;
    },
    find: function(ctx) {
        let that = this;
        if(that.filterModel != 'Select a model'){
            var params = that.buildRequestParams();
            params.append("page", ctx.currentPage);
            
            var request = {
                params: params,
            };

            return HTTP.get("/kenya/report_builder", request)
                .then((response) => {
                that.tableData = response.data.row_data;
                that.totalRows = response.data.totalRows;
                return that.tableData;
            })
            .catch((error) => {
                HandleErrors.HandleErrors(error);
            });
        } 

        this.fileDownload == false;
    },
    clear() {
        // called by the clear button. Resets the page to the initial state.
        this.perPageOptions.currentPage = 1;
        this.queryFieldsetCount = 1;
        this.fieldArray = [];
        this.operatorArray = [];
        this.termArray = [];
        this.search_phrase = "";
        this.sortDesc = false;
        this.selectedRows = [];
        // set the default values for the select column and select operator fields to display default text
        this.fieldArray[0] = "";
        this.operatorArray[0] = "";
        this.clearUrlQueryParams();
        this.updateTable();
    },
    getModelColumns: function() {
        let params = {}
        let that = this;
        if(that.filterModel != 'Select a model'){
            params.model = that.filterModel;
        }
        return HTTP.get("/kenya/report_builder_model_fields/", {
            params: params
        })
        .then((response) => {
            // that.fieldOptions = response.data;
            that.buildFields(response.data.fields);
            this.fieldOptions = [];
            // Add a default value to display a placeholder help text.
            this.fieldOptions.push({
                value: "",
                text: "Select a field",
                disabled: true,
            });
            this.fields.forEach((field) => {
                this.fieldOptions.push({ value: field.key, text: field.key });
            });
            // remove the "null" field from the fieldOptions array
            this.fieldOptions.splice(1, 1);
        })
        .catch((error) => {
            HandleErrors.HandleErrors(error);
        });
    },
    buildFields(field_data) {
        let that = this;
        that.fields = [];
        that.fields.push({
            value: "",
            text: "Select a field",
            disabled: true,
        });
        field_data.forEach((field) => {
            that.fields.push({ key: field, title: field, sortable: true });
        });
    },
    incrementQueryFieldset() {
        // gets called when the user clicks the '+' button on the right of the search form
        this.queryFieldsetCount += 1;
    },
    removeQueryFieldset(index) {
        // gets called when the user clicks the '-' button on the right of the search form
        this.queryFieldsetCount -= 1;
        this.fieldArray.splice(index, 1);
        this.operatorArray.splice(index, 1);
        this.termArray.splice(index, 1);
        this.updateTable();
    },
  },
  beforeRouteUpdate(to, from, next) {
    // This router-guard is meant to refresh the table whenever the URL query params are updated. This is mostly
    // to handle the back/forward buttons in the browser. When the user clicks back, it will update the URL
    // params. We want the table to update according to what the URL displays.
    // this.unpackUrlQueryParams(to.query);
    // this.updateTable();
    next();
  },
};
</script>

<style scoped>
.clickable{
  cursor: pointer;
}
</style>
